/*
 * File: input-switch.ts
 * File Created: 2024-09-13 09:29:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-14 08:50:23
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";
import { AnyHelper } from "@root/core";
import { PropInnateSync } from "@root/core/vue-props";
import { BaseInputComponent } from "../core/lib/base-input-component";

export interface ISwitchData {
    "text-on": string;
    "text-off": string;
}
const defaultData = {
    "text-on": "w_On",
    "text-off": "w_Off",
};

@Component
export default class InputSwitch extends BaseInputComponent {
    @PropInnateSync("value", { type: Boolean, default: null })
    innateValue!: boolean | null;

    @Prop({ type: Object, required: false })
    declare data: ISwitchData;
    get mergedData() {
        return { ...defaultData, ...this.data };
    }

    get oValue(): boolean | null {
        if (this.innateValue == undefined) return this.innateValue;
        return AnyHelper.toBoolean(this.innateValue);
    }
}
